import { ContainerModule } from 'inversify';
import { OfflineDetectionService } from '../services/OfflineDetection.service';
import { TYPES } from './types';
import { DownloadCaseForOfflineUseCase } from '../services/DownloadCaseForOffline.usecase';
import { OfflineDB } from '../services/OfflineDB';
import { OfflineUtilsService } from '../services/OfflineUtils.service';
import { DownloadForOfflineButtonController } from '../components/DownloadForOfflineButton.controller';

export const iocModule = new ContainerModule((bind) => {
  bind<OfflineDetectionService>(TYPES.OfflineDetectionService).to(OfflineDetectionService).inSingletonScope();
  bind<DownloadCaseForOfflineUseCase>(TYPES.DownloadCaseForOfflineUseCase).to(DownloadCaseForOfflineUseCase);
  bind<OfflineDB>(TYPES.OfflineDB).to(OfflineDB).inSingletonScope();
  bind<OfflineUtilsService>(TYPES.OfflineUtilsService).to(OfflineUtilsService);
  bind<DownloadForOfflineButtonController>(TYPES.DownloadForOfflineButtonController).to(
    DownloadForOfflineButtonController
  );
});
